import { Anchor, Button, Stack, Table, Text, Title } from "@mantine/core";
import { useMutation } from "@tanstack/react-query";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";
import { getCurrentUser } from "../shared/getCurrentUser";
import { RestApi } from "../shared/RestApi";
import { NavBarContainer } from "./NavBarContainer";

export function UserInfoPage() {
  const { t } = useTranslation();
  const user = getCurrentUser()!;
  const [resendMsg, setResendMsg] = React.useState<string | null>(null);

  const resendMutation = useMutation({
    mutationFn: () => RestApi.resendConfirmationEmail(),
    onSuccess: () => {
      setResendMsg(t("userInfo.resentEmail", { email: user.Email }));
    },
    onError: () => {
      setResendMsg(t("userInfo.resendError"));
    },
  });

  return (
    <NavBarContainer variant="marketing" title={t("userInfo.title")}>
      <Stack gap="md">
        <Text>{t("userInfo.congrats")}</Text>
        <Table>
          <Table.Tbody>
            <Table.Tr>
              <Table.Td>{t("userInfo.userId")}</Table.Td>
              <Table.Td>{user.UserId}</Table.Td>
            </Table.Tr>
            <Table.Tr>
              <Table.Td>{t("userInfo.name")}</Table.Td>
              <Table.Td>{user.Name}</Table.Td>
            </Table.Tr>
            <Table.Tr>
              <Table.Td>{t("userInfo.email")}</Table.Td>
              <Table.Td>{user.Email}</Table.Td>
            </Table.Tr>
            <Table.Tr>
              <Table.Td>{t("userInfo.emailConfirmed")}</Table.Td>
              <Table.Td>
                {user.EmailConfirmed ? "✓" : "✗"}{" "}
                {!user.EmailConfirmed && (
                  <Button
                    size="xs"
                    ml="sm"
                    loading={resendMutation.isPending}
                    onClick={() => resendMutation.mutate()}
                  >
                    {t("userInfo.resend")}
                  </Button>
                )}
              </Table.Td>
            </Table.Tr>
            <Table.Tr>
              <Table.Td>{t("userInfo.version")}</Table.Td>
              <Table.Td>
                {user.Bought ? (
                  <>
                    <Text>{t("userInfo.fullVersion")}</Text>
                    {user.PaymentId && (
                      <Text size="sm">
                        {user.PaymentMethod}: {user.PaymentId}
                      </Text>
                    )}
                  </>
                ) : (
                  <>
                    <Text>{t("userInfo.freeVersion")}</Text>
                    <Anchor component={Link} to="/buy">
                      {t("userInfo.buyApp")}
                    </Anchor>
                  </>
                )}
              </Table.Td>
            </Table.Tr>
            <Table.Tr>
              <Table.Td>{t("userInfo.accountType")}</Table.Td>
              <Table.Td>
                {user.AccountType}: {user.AccountEmail}
              </Table.Td>
            </Table.Tr>
          </Table.Tbody>
        </Table>
        {resendMsg && <Text>{resendMsg}</Text>}
        {user.IsAdmin && (
          <Anchor component={Link} to="/admin">
            {t("userInfo.admin")}
          </Anchor>
        )}
        <Title order={5}>{t("userInfo.distributorPortal")}</Title>
        <Anchor component={Link} to="/distributorportal">
          {t("userInfo.openDistributorPortal")}
        </Anchor>
      </Stack>
    </NavBarContainer>
  );
}
